
//============================================================================
// Name        : Schedule.tsx
// Purpose     : Implement Schedule UI
// Created     : 2019-08-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import axios from "axios";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import Switch from "react-switch";
import SOInspectDialog from "./SOInspectDialog";
import { ChangeInputEvent, IReduxReducers, IScheduleState, ISoItem, ScheduleActions } from "./types";

const switchStyle = css`
    display: flex;
    align-items: center;
`;
const plainCell = css`
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: left;
`;
const contentCell = css`
    padding-left: 15px;
    padding-right: 15px;
    text-align: center;
    border: 1px #ccc solid;
`;
const blueCell = css`
    background-color: #2770a8;
    color: #ffffff;
    text-align: center;
`;
const leftBlueCell = css`
    background-color: #2770a8;
    color: #ffffff;
    width: 380px;
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
`;
const leftBlueCellContent = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const emptyRow = css`height: 20px;`;
const redCell = css`
    color: red;
`;
const rightAlign = css`text-align: right`;
const magnifyStyle = css`
    cursor: pointer;
    width: auto;
    height: 25px;
    margin-left: 10px;
`;

class Schedule extends React.Component<IScheduleState> {
    constructor(props: IScheduleState) {
        super(props);
        // Save properties sent from Rails in the wrapper into the store
        this.props.storeInitialState(props);

        // Force the sidebar to close
        setTimeout(() => {
            const bodyEl = document.getElementsByTagName("body")[0];
            if (!bodyEl.classList.contains("hidden-menu")) {
                $(document).ready(() => $("#hide-menu a").trigger("click"));
            }
        // tslint:disable-next-line: align
        }, 500);
    }

    resizeUpdate = () => {
        setTimeout(() => {
            const containerEl = document.getElementById("allContainer");
            let width = containerEl ? containerEl.offsetWidth : window.innerWidth;

            const bodyEl = document.getElementsByTagName("body")[0];
            if (bodyEl.classList.contains("hidden-menu")) {
                width -= 980;
            }
            else {
                width -= 880;
            }
            this.setState({ width });
        // tslint:disable-next-line: align
        }, 500);
    }

    componentWillMount() {
        this.resizeUpdate();
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeUpdate);
        $("#hide-menu a").on("click", this.resizeUpdate);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeUpdate);
    }

    onChange = (event: ChangeInputEvent) => {
        const newState = { [event.target.name]: event.target.value };
        this.props.updateState(newState);
    }
    onToggleLbsDisplay = (value: boolean) => {
        const newState = { showAsLbs: value };
        this.props.updateState(newState);
    }
    onToggleCaseDisplay = (value: boolean) => {
        const newState = { showAsCases: value };
        this.props.updateState(newState);
    }

    getEditScheduleUrl = (dayRange: string) => {
        return this.props.editScheduleUrl + `/?id=${this.props.product.id}&dayRange=${dayRange}`;
    }

    //========================================================================

    sumPastDueSlice = (): number => {
        return this.props.pastDueSlice.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    sumScheduledSlice = (): number => {
        return this.props.scheduledSlice.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    sumScheduledSlice1 = (): number => {
        return this.props.scheduledSlice1.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    sumScheduledSlice2 = (): number => {
        return this.props.scheduledSlice2.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    sumScheduledSlice3 = (): number => {
        return this.props.scheduledSlice3.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    sumScheduledSlice4 = (): number => {
        return this.props.scheduledSlice4.reduce((accTotal, p) => accTotal + p.needed_qty, 0);
    }

    //========================================================================

    sumSoPdItems = (): number => {
        return this.props.soPdItems.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    sumSoItems = (): number => {
        return this.props.soItems.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    sumSoItems1 = (): number => {
        return this.props.soItems1.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    sumSoItems2 = (): number => {
        return this.props.soItems2.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    sumSoItems3 = (): number => {
        return this.props.soItems3.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    sumSoItems4 = (): number => {
        return this.props.soItems4.reduce((accTotal, so) => accTotal + so.order_qty, 0)
            * parseFloat(this.props.storageUnit.measure_unit);
    }

    getPastWeekNetAvailable = (): number => {
        return this.props.qtyOnHandLbs - this.sumPastDueSlice() - this.sumSoPdItems();
    }

    getWeekNetAvailable = (): number => {
        return this.props.qtyOnHandLbs - this.sumScheduledSlice() - this.sumSoItems();
    }

    getWeek1NetAvailable = (): number => {
        return this.getOnHandWeek1() - this.sumScheduledSlice1() - this.sumSoItems1();
    }

    getWeek2NetAvailable = (): number => {
        return this.getOnHandWeek2() - this.sumScheduledSlice2() - this.sumSoItems2();
    }

    getWeek3NetAvailable = (): number => {
        return this.getOnHandWeek3() - this.sumScheduledSlice3() - this.sumSoItems3();
    }

    getWeek4NetAvailable = (): number => {
        return this.getOnHandWeek4() - this.sumScheduledSlice4() - this.sumSoItems4();
    }

    //========================================================================

    getOnHandWeek1 = (): number => this.getWeekNetAvailable();
    getOnHandWeek2 = (): number => this.getWeek1NetAvailable();
    getOnHandWeek3 = (): number => this.getWeek2NetAvailable();
    getOnHandWeek4 = (): number => this.getWeek3NetAvailable();

    //========================================================================

    inspectSoCallback = async (startDay: number, endDay: number, _event: any) => {
        const resp = await axios.get(this.props.soItemsUrl, { params: { startDay, endDay }});
        if (resp.status == 200) {
            this.props.showSOInspectDialog(resp.data);
        }
    }

    valueInUnits = (value: number, drillIn: boolean = false,
                    params: { startDay: number, endDay: number } = null): JSX.Element => {

        const cases = value / parseFloat(this.props.storageUnit.measure_unit);

        if (!drillIn) {
            return (
                <React.Fragment>
                    {this.props.showAsLbs && <div>{value}</div>}
                    {this.props.showAsCases && <div>{cases}</div>}
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <div css={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                    <div css={{ width: 25 }}>&nbsp;</div>
                    <div>
                        {this.props.showAsLbs && <div>{value}</div>}
                        {this.props.showAsCases && <div>{cases}</div>}
                    </div>
                    {value > 0 && <img onClick={this.inspectSoCallback.bind(this, params.startDay, params.endDay)} css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />}
                </div>
            </React.Fragment>
        );
    }

    render() {
        const currentDate = moment(new Date());
        const currentDateStr = currentDate.format("MM/DD/YY");

        const curDatePlus7  = moment(new Date()).add(7, "days").format("MM/DD/YY");
        const curDatePlus8  = moment(new Date()).add(8, "days").format("MM/DD/YY");
        const curDatePlus14 = moment(new Date()).add(14, "days").format("MM/DD/YY");
        const curDatePlus15 = moment(new Date()).add(15, "days").format("MM/DD/YY");
        const curDatePlus21 = moment(new Date()).add(21, "days").format("MM/DD/YY");
        const curDatePlus22 = moment(new Date()).add(22, "days").format("MM/DD/YY");
        const curDatePlus28 = moment(new Date()).add(28, "days").format("MM/DD/YY");

        return (
            <React.Fragment>
                <h1>{this.props.product.alu}</h1>
                <h2>{this.props.product.description}</h2>

                <div css={{ display: "flex", justifyContent: "center", marginTop: 15 }}>
                    <table>
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td css={plainCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>Show UOM in:</span>
                                        <div css={switchStyle}>
                                            <span css={switchStyle}>
                                                <span css={{ fontSize: "16px", marginRight: "10px", marginLeft: "10px" }}>Lbs.</span>
                                                <Switch onChange={this.onToggleLbsDisplay} checked={this.props.showAsLbs} />
                                            </span>
                                            <span css={switchStyle}>
                                                <span css={{ fontSize: "16px", marginRight: "10px", marginLeft: "10px" }}>Cases</span>
                                                <Switch onChange={this.onToggleCaseDisplay} checked={this.props.showAsCases} />
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    Past Due
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    {currentDateStr} - {curDatePlus7}<br/>
                                    0 - 7 Days
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    {curDatePlus8} - {curDatePlus14}<br/>
                                    8 - 14 Days
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    {curDatePlus15} - {curDatePlus21}<br/>
                                    15 - 21 Days
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    {curDatePlus22} - {curDatePlus28}<br/>
                                    22 - 28 Days
                                </td>
                                <td css={[plainCell, blueCell]}>
                                    Past {curDatePlus28}<br/>
                                    Over 28 Days
                                </td>
                            </tr>
                            <tr>
                                <td css={leftBlueCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>Current / Expected Qty on Hand</span>
                                        <div>
                                            {this.props.showAsLbs && <div>Lbs.</div>}
                                            {this.props.showAsCases && <div>Cases</div>}
                                        </div>
                                    </div>
                                </td>
                                <td css={contentCell}></td>
                                <td css={contentCell}>
                                    {this.props.showAsLbs && <div>{this.props.qtyOnHandLbs}</div>}
                                    {this.props.showAsCases && <div>{this.props.qtyOnHandCases}</div>}
                                </td>
                                <td css={contentCell}>{this.valueInUnits(this.getOnHandWeek1())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getOnHandWeek2())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getOnHandWeek3())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getOnHandWeek4())}</td>
                            </tr>
                            <tr css={emptyRow}></tr>
                            <tr>
                                <td css={leftBlueCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>Scheduled Production Qty</span>
                                        <div>
                                            {this.props.showAsLbs && <div>Lbs.</div>}
                                            {this.props.showAsCases && <div>Cases</div>}
                                        </div>
                                    </div>
                                </td>
                                <td css={contentCell}>{this.valueInUnits(this.sumPastDueSlice())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumScheduledSlice())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumScheduledSlice1())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumScheduledSlice2())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumScheduledSlice3())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumScheduledSlice4())}</td>
                            </tr>
                            <tr css={[emptyRow, redCell]}>
                                <td>Max Achievable Schedule Production % (Based on Components Availability)</td>
                                <td></td>
                                <td css={rightAlign}>
                                    0%
                                    <a href="#" title="Drill in">
                                        <img css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />
                                    </a>
                                </td>
                                <td css={rightAlign}>
                                    0%
                                    <a href="#" title="Drill in">
                                        <img css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />
                                    </a>
                                </td>
                                <td css={rightAlign}>
                                    0%
                                    <a href="#" title="Drill in">
                                        <img css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />
                                    </a>
                                </td>
                                <td css={rightAlign}>
                                    0%
                                    <a href="#" title="Drill in">
                                        <img css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />
                                    </a>
                                </td>
                                <td css={rightAlign}>
                                    0%
                                    <a href="#" title="Drill in">
                                        <img css={magnifyStyle} src="/images/magnifying-glass.png" alt="Drill in" />
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td css={leftBlueCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>Max Achievable Schedule Production Qty</span>
                                        <div>
                                            {this.props.showAsLbs && <div>Lbs.</div>}
                                            {this.props.showAsCases && <div>Cases</div>}
                                        </div>
                                    </div>
                                </td>
                                <td css={contentCell}></td>
                                <td css={contentCell}>SD Max Achievable<br/>(Pending on Mod)</td>
                                <td css={contentCell}>SD Max Achievable +1<br/>(Pending on Mod)</td>
                                <td css={contentCell}>SD Max Achievable +2<br/>(Pending on Mod)</td>
                                <td css={contentCell}>SD Max Achievable +3<br/>(Pending on Mod)</td>
                                <td css={contentCell}>SD Max Achievable +4<br/>(Pending on Mod)</td>
                            </tr>
                            <tr css={emptyRow}></tr>
                            <tr>
                                <td css={leftBlueCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>Open Sales Qty</span>
                                        <div>
                                            {this.props.showAsLbs && <div>Lbs.</div>}
                                            {this.props.showAsCases && <div>Cases</div>}
                                        </div>
                                    </div>
                                </td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoPdItems())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoItems(), true, { startDay: 0, endDay: 7 })}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoItems1(), true, { startDay: 8, endDay: 14 })}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoItems2(), true, { startDay: 15, endDay: 21 })}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoItems3(), true, { startDay: 22, endDay: 28 })}</td>
                                <td css={contentCell}>{this.valueInUnits(this.sumSoItems4(), true, { startDay: 28, endDay: -1 })}</td>
                            </tr>
                            <tr css={emptyRow}></tr>
                            <tr>
                                <td css={leftBlueCell}>
                                    <div css={leftBlueCellContent}>
                                        <span>End of Week Net Available</span>
                                        <div>
                                            {this.props.showAsLbs && <div>Lbs.</div>}
                                            {this.props.showAsCases && <div>Cases</div>}
                                        </div>
                                    </div>
                                </td>
                                <td css={contentCell}></td>
                                <td css={contentCell}>{this.valueInUnits(this.getWeekNetAvailable())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getWeek1NetAvailable())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getWeek2NetAvailable())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getWeek3NetAvailable())}</td>
                                <td css={contentCell}>{this.valueInUnits(this.getWeek4NetAvailable())}</td>
                            </tr>
                            <tr css={emptyRow}></tr>
                            <tr>
                                <td></td>
                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("-1")} className="man-btn man-green-btn">
                                        View<br />Schedule
                                    </a>
                                </td>

                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("0-7")} className="man-btn man-green-btn">
                                        View / Edit<br />Schedule
                                    </a>
                                </td>
                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("8-14")} className="man-btn man-green-btn">
                                        View / Edit<br />Schedule
                                    </a>
                                </td>
                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("15-21")} className="man-btn man-green-btn">
                                        View / Edit<br />Schedule
                                    </a>
                                </td>
                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("22-28")} className="man-btn man-green-btn">
                                        View / Edit<br />Schedule
                                    </a>
                                </td>
                                <td css={{ textAlign: "center" }}>
                                    <a href={this.getEditScheduleUrl("28-90")} className="man-btn man-green-btn">
                                        View / Edit<br />Schedule
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <SOInspectDialog />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReduxReducers) => ({
    showAsLbs:   state.schedule.showAsLbs,
    showAsCases: state.schedule.showAsCases
});

const mapDispatchToProps = dispatch => ({
    storeInitialState: (props: IScheduleState) => dispatch({
        type: ScheduleActions.StoreInitialState,
        payload: props
    }),
    updateState: (newState: object) => dispatch({
        type: ScheduleActions.UpdateState,
        payload: newState
    }),
    showSOInspectDialog: (inspectSO: ISoItem[]) => dispatch({
        type: ScheduleActions.ShowSOInspectDialog,
        inspectSO
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
